import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tag as AntTag } from "antd";
import { forwardRef } from "react";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import "./Badge.scss";
const CSS_PREFIX = `lav-components-badge`;
export const Badge = forwardRef((_a, ref) => {
    var { className = "", variant = "accent", style = "solid", type = "text" } = _a, antTagProps = __rest(_a, ["className", "variant", "style", "type"]);
    return (_jsx(AntTag, Object.assign({ ref: ref, className: classNames(styleClasses(CSS_PREFIX, {
            style,
            type,
            variant,
        }), { [className]: !!className }) }, antTagProps)));
});
Badge.displayName = "Badge";
